module.exports = __webpack_public_path__ + "static/media/listaDeTarefas.72ec2a8e.png";